<template>
  <div class="modal-popup" v-if="selectedAgencyPayment">
    <div class="modal fade" id="createAgencyPaymentModal" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 v-if="updateProcess" class="title mt-2 ml-2">Ödeme Kaydı Güncelle</h3>
            <h3 v-else class="title mt-2 ml-2">Ödeme Kaydı Oluştur</h3>

            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>

          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="input-box">
                      <label class="label-text">Ödeme Tutarı ( € )</label>
                      <input class="form-control" v-model="selectedAgencyPayment.amount" id="paymentAmount" type="number" placeholder="">
                    </div>
                    <div class="input-box">
                      <label class="label-text">Ödeme Detayı</label>
                      <input class="form-control" v-model="selectedAgencyPayment.reason" id="paymentReason" type="text" placeholder="">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="input-box">
                      <base-select-input
                          v-model="selectedAgencyPayment.type"
                          :optionList="paymentTypes"
                          :label="'Ödeme Tipi'"/>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div v-if="failed" class="modal-footer border-top-0 pt-0 mr-5">
            <span style="color: #880e4f">Başarısız</span>
          </div>

          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">iptal</button>
            <button v-if="!updateProcess" @click="accept" type="button" class="theme-btn theme-btn-small" :class="loading ? 'disabled' : ''"><i v-if="loading" class="la la-spinner la-spin"></i> Ekle</button>
            <button v-else @click="accept" type="button" class="theme-btn theme-btn-small" :class="loading ? 'disabled' : ''"><i v-if="loading" class="la la-spinner la-spin"></i>Güncelle</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseSelectInput from "../base/BaseSelectInput";
export default {
  name: "CreateAgencyPaymentPopup",
  components: {BaseSelectInput},
  data:function (){
    return{
      loading:false,
      failed:false,
      paymentTypes:[{id:'Cash', name:'Cash'},{id:'Credit Card', name:'Credit Card'},{id:'Other', name:'Other'}]
      // agencyPayment: {}
    }
  },
  computed:{
    outline:{
      get(){
        return this.$store.getters.getSelectedAgencyOutline;
      }
    },
    updateProcess:{
      get(){
        return this.$store.getters.getUpdateProcess;
      }
    },
    selectedAgencyPayment:{
      get(){
        return this.$store.getters.getSelectedAgencyPayment;
      }
    }
  },
  methods:{
    accept(){
      if(!this.loading) {
        this.loading = true;
        this.selectedAgencyPayment.agencyId = this.outline.agency.id;
        if(this.updateProcess){
          this.$store.dispatch("updateAgencyPayment", this.selectedAgencyPayment).then(response => {
            this.$store.dispatch("loadAgencyPaymentOutlines");
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
            $("#createAgencyPaymentModal").modal("hide");
          }).catch(()=>{
            this.failed = true;
          }).finally(() => {
            this.loading = false;
          })

        }else{
          this.$store.dispatch("createAgencyPayment", this.selectedAgencyPayment).then(response => {
            this.$store.dispatch("loadAgencyPaymentOutlines");
            Swal.fire({
              icon: 'success',
              title: 'Başarılı',
              text: '',
            })
            $("#createAgencyPaymentModal").modal("hide");
          }).catch(()=>{
            this.failed = true;
          }).finally(() => {
            this.loading = false;
          })
        }

      }
    }
  },
  mounted() {
    $('#createAgencyPaymentModal').on('shown.bs.modal', (e) => {
      this.failed = false;
      this.agencyPayment = {};
    })

  },
}
</script>

<style scoped>

</style>